import { render } from "./SliderPuzzle.vue?vue&type=template&id=86f92bc6&scoped=true"
import script from "./SliderPuzzle.vue?vue&type=script&lang=js"
export * from "./SliderPuzzle.vue?vue&type=script&lang=js"

import "./SliderPuzzle.vue?vue&type=style&index=0&id=86f92bc6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f92bc6"]])

export default __exports__